import React from 'react';
import { useFeatureFlag } from '@moda/portal-stanchions';
import { useParams } from 'react-router-dom';
import { ControlLink, Stack, Text } from '@moda/om';
import { US_RETURN_OPTIONS_FEDEX, INTERNATIONAL_RETURN_OPTIONS } from '../../constants';
import { useReturnSummary } from '../../hooks/useReturnSummary';
import { useUser } from '../../hooks/useUser';

import './ReturnInformation.scss';

export enum ReturnMethod {
  OriginalPaymentMethod = 0,
  SiteCredit = 1
}

export const ReturnInformation: React.FC = () => {
  const { shipmentNumber } = useParams<{ shipmentNumber: string }>();
  const { user } = useUser();
  const { returnSummary } = useReturnSummary({ shipmentNumber });
  const isNewReturnPolicyFeatureEnabled = useFeatureFlag('new-return-policy', [
    { default: false },
    { if: true, then: true }
  ]);
  const isNewReturnPolicyEnabled = isNewReturnPolicyFeatureEnabled && user.affiliate !== 1;

  if (!returnSummary) return null;

  const options =
    returnSummary.attributes.countryCode === 'US'
      ? US_RETURN_OPTIONS_FEDEX
      : INTERNATIONAL_RETURN_OPTIONS;

  const returnOption = options.find((option: { value: number }) => {
    return returnSummary.attributes.returnOptionId === option.value;
  });

  const returnPolicyUrl = 'https://help.modaoperandi.com/hc/en-us/articles/211521863-Return-Policy';

  return (
    <Stack space={3}>
      <Stack space={2}>
        <Text className="ReturnInformation__title" treatment="h5">
          Refund Method
        </Text>

        {returnSummary.attributes.returnMethodId === ReturnMethod.OriginalPaymentMethod && (
          <Stack space={0}>
            <Text color="cement">Original Payment Method</Text>
            {isNewReturnPolicyEnabled ? (
              <Text color="cement">
                If an item isn&apos;t received by the carrier within 14 days, then the refund will
                be issued as site credit. Please note the item{' '}
                <ControlLink href={returnPolicyUrl} underlined>
                  Return Policy
                </ControlLink>
                .
              </Text>
            ) : (
              <Text color="cement">
                Refund will be issued to your original method of payment(s).
              </Text>
            )}
          </Stack>
        )}

        {returnSummary.attributes.returnMethodId === ReturnMethod.SiteCredit && (
          <Text color="cement">Site Credit</Text>
        )}
      </Stack>

      <Stack space={2}>
        <Text className="ReturnInformation__title" treatment="h5">
          Return Options
        </Text>

        {returnOption && (
          <Stack space={0}>
            <Text color="cement">{returnOption.label} </Text>
            <Text color="cement">{returnOption.description[0]} </Text>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
